
import Vue from "vue"

export type ChecklistAction = {
  key: string
  label: string
  description?: string
  completed: boolean
}

export default Vue.extend({
  name: "ProgressActionChecklist",
  props: {
    actions: { type: Array as () => ChecklistAction[], default: () => [] },
  },
  methods: {
    actionIconColor(completed: boolean): string {
      if (this.$vuetify.theme.dark) {
        return completed ? "grey lighten-1" : "grey lighten-2"
      }
      return completed ? "grey" : "grey lighten-1"
    },
  },
})
